import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from "vue";
import { transactionsColumns } from "@/util";
import { orgStore } from "@/hooks";
import { PanelCard, SelectInput, GroupableTable } from "@/components/common";


/**
 * A tab for managing teams within an organization.
 */
const __default__ = {
  name: "TransactionTab",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const modeOptions = ["All", "Monthly"];

const mode = ref<"All" | "Monthly">("Monthly");

const transactions = computed(() =>
  mode.value == "All" ? orgStore.allTransactions : orgStore.monthlyTransactions
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), null, {
    default: _withCtx(() => [
      _createVNode(_unref(GroupableTable), {
        columns: _unref(transactionsColumns),
        rows: transactions.value,
        "row-key": "id",
        "item-name": "transaction",
        "default-sort-desc": "",
        "default-sort-by": "timestamp"
      }, {
        "header-right": _withCtx(() => [
          _createVNode(_unref(SelectInput), {
            modelValue: mode.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mode).value = $event)),
            outlined: "",
            dense: "",
            label: "Period",
            class: "q-mb-sm",
            options: modeOptions
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["columns", "rows"])
    ]),
    _: 1
  }))
}
}

})